import React from 'react';
import ClientCard from './ClientCard';

export default function ClientList(props) {
  return (
    <section className="client-list">
      <ul>
        {props.clients.map((client, index) => (
          <li key={index}>
            <ClientCard
              key={index}
              name={`${client.first_name} ${client.last_name}`}
              firstLetters={`${client.first_name[0].toUpperCase()}${client.last_name[0].toUpperCase()}`}
              img={client.photo}
              id={client.id}
              lastActive={client.last_active}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
